export default "__VITE_ASSET__D9Ur6tFi__"